var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Stretch from '../Stretches/Model';
var CollaboratorStretch = /** @class */ (function (_super) {
    __extends(CollaboratorStretch, _super);
    function CollaboratorStretch(props) {
        var _this = _super.call(this, props) || this;
        if (props.disabled_at) {
            _this.disabled_at = new Date(props.disabled_at);
        }
        _this.operatorName = props.operatorName;
        _this.operator_id = props.operator_id;
        return _this;
    }
    return CollaboratorStretch;
}(Stretch));
export default CollaboratorStretch;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/Model.ts
// module id = 330
// module chunks = 0